/**
 * Render Search on Map.
 *
 * @author: Fabio Junior
 * Date: 16/12/13
 * Time: 10:57
 */

import { DefaultRequest } from 'scripts/api';
import { getResourceTo, toastNotification } from 'react/utils/utils';


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.MultiSearchOnMap = Greenmile.Toolbar.Map.MultiSearchOnMap || {};

Greenmile.Toolbar.Map.MultiSearchOnMap = function (selector, map) {

    if (!selector || !map) {
        return false;
    }

    const debounceTime = 1500;
    const DOWN_ARROW = 40;
    const ENTER = 13;
    const TAB = 9;
    const ESC = 27;
    const handleToolbarSearchContainer = new Greenmile.Toolbar.Map.Util.handleToolbarSearchContainer(selector);
    this.searchAddressOnMap = new Greenmile.Toolbar.Map.SearchAddressOnMap(selector, map);

    // Requests in progress 
    this.requestDriversInProgress = false;
    this.requestOrdersInProgress = false;
    this.requestLocationInProgress = false;

    // Timeout ID for searches
    this.callRequestsTimeout = null;

    this.goToNextAddress = () => {
        this.canHide = false;
        const streetSearchResultSelector = selector +  " .streetSearchResult select";
        $(streetSearchResultSelector).trigger("focus");
        $(streetSearchResultSelector).val( $(streetSearchResultSelector + " option:first").val() );
    };

    this.toggleLoadingSpinner = (forceShow) => {
        const searchInput = document.querySelector(selector + ' #searchStreet');
        if (forceShow || this.requestDriversInProgress || this.requestOrdersInProgress || this.requestLocationInProgress) {
            searchInput.classList.add("searchInProgress");
        } else {
            searchInput.classList.remove("searchInProgress");
        }
    };

    this.abortRequestsInProgress = () => {
        if(this.requestDrivers && this.requestLocations && this.requestOrders) {
            this.requestDrivers.abort();
            this.requestLocations.abort();
            this.requestOrders.abort();

            this.requestDriversInProgress = false;
            this.requestOrdersInProgress = false;
            this.requestLocationInProgress = false;

            this.toggleLoadingSpinner();
        }
    };

    this.addListeners = () => {
        const inputSearchStreet = $(selector + " input[name='searchStreet']");
        
        const clearResultsAndStartLoading = () => {
            const group = document.querySelector(`${selector} #multiSearchOnMap`);
            group && (group.innerHTML = "");
            this.toggleLoadingSpinner(true);
        };
        
        const executeListeners = () => {
            const group = document.querySelector(`${selector} #multiSearchOnMap`);

            const triggerRequests = () => {
                this.requestGeocode();

                if (!selector.match(/popupEvent/g)) {
                    this.requestTruckListener();
                    this.requestDriverListener();
                    this.requestOrderListener();
                    this.requestLocation();

                }
            }
            
            triggerRequests();
            
            const interval = setInterval(() => {
                if(!this.requestDriversInProgress && 
                    !this.requestOrdersInProgress && 
                    !this.requestLocationInProgress
                ) {
                    if(group && group.innerHTML === '') {
                        handleToolbarSearchContainer.showNotDataText();
                    } else {
                        handleToolbarSearchContainer.showContent();
                    }   

                    clearInterval(interval);
                }
            }, 500);
        };

        const onInputSearchStreet = (e) => {

            if (e.keyCode === DOWN_ARROW) {
                this.goToNextAddress();
            } else if (e.keyCode === ENTER) {
                clearResultsAndStartLoading();
                clearTimeout(this.callRequestsTimeout);
                executeListeners();
            } else if (e.keyCode === ESC || e.target.value === "") {
                inputSearchStreet.val("");
                clearTimeout(this.callRequestsTimeout);
                this.abortRequestsInProgress();
            } else {
                this.mountContainerResult();

                clearResultsAndStartLoading();
                clearTimeout(this.callRequestsTimeout);
                this.callRequestsTimeout = setTimeout(executeListeners, debounceTime);
            }
        }

        inputSearchStreet.on("keyup", onInputSearchStreet);

        if (!selector.match(/popupEvent/g)) {
            // Hide results container and cancel search when clicking anywhere else on the document
            const hideResults = (e) => {
                if (e.target.id !== 'searchStreet') {
                    this.canHide = true;
                    this.clearIfCanHide();
                }
            };

            document.addEventListener('click', hideResults);

            //Show results container if input value is not empty or hide it otherwise
            const searchInput = document.querySelector(selector + ' #searchStreet');
            if (searchInput) {
                const showResultsIfNotEmpty = (e) => {
                    e.target.setAttribute('autocomplete', 'new-password'); //avoids showing Chrome's autocomplete suggestions above our results container
                    if (!e.target.value) {
                        this.canHide = true;
                        this.clearIfCanHide();
                    } else {
                        this.canHide = false;
                        $(selector + ' .streetSearchResult').show();
                    }
                };

                searchInput.addEventListener('input', showResultsIfNotEmpty);
                searchInput.addEventListener('focus', showResultsIfNotEmpty);
            }
        }
    };

    this.requestTruckListener = () => {
        App.Views.Map.addAllMarkers();
        this.requestTruck();
        const ie = navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf('Trident') !== -1;
        if (ie > 0) {
            this.addListenerForIe();
        }
    };

    this.requestDriverListener = function () {
        App.Views.Map.addAllMarkers();
        this.requestDriver();
    };

    this.requestOrderListener = function () {
        App.Views.Map.addAllMarkers();
        this.requestOrder();
    };

    this.addListenerForIe = () => {

        var option = document.querySelector(selector + " .streetSearchResult select");
        option.addEventListener('change', (function (scope) {
            return function (e) {
                e.stopPropagation();
                scope.getElementOption(e);
            };
        }(this)));

    };

    this.requestGeocode = () => {
        const gGeocode = new Greenmile.Geocoding(map);
        const successCallback = (data) => this.renderGroupOptions('address', data);
        const errorCallback = () => this.renderGroupOptions('address', []);
        gGeocode.geocode(selector + " input[name='searchStreet']", successCallback, errorCallback);
    };

    this.getElementOption = (e) => {

        const options = document.querySelectorAll(selector + " .streetSearchResult select option");
        const target = e.target.value;

        for (let i = 0, j = i; j < options.length; j++) {
            const key = options[j].value;
            const kind = options[j].getAttribute("kind");
            if (key === target) {
                switch (kind) {
                    case "EQUIPMENT":
                        this.addClickEquipmentListeners(e, j);
                        break;
                    case "LOCATION":
                        this.addClickLocationListeners(e, j);
                        break;
                    case "DRIVER":
                        this.addClickEquipmentListeners(e, j);
                        break;
                    case "marker":
                        this.addClickStreetSearchListeners(e, j);
                        break;
                    case "ORDER":
                        this.addClickOrderListeners(e, j);
                        break;
                    default:
                        console.log("Greenmile.Toolbar.Map.MultiSearchOnMap in getElementOptions don't have default element");
                        break;
                }
            }
        }
    };

    this.clearIfCanHide = () => {
        if (this.canHide === true) {
            clearTimeout(this.callRequestsTimeout);
            this.abortRequestsInProgress();
            $(selector + " .streetSearchResult").hide();
            $(selector + " .streetSearchResult").html();
            $(selector + " input[name='searchStreet']").val("");
        }
    };

    this.requestTruck =  () => {
        const markers = Monet.Session.Maps.mainMap.markers;

        let keySearch = selector + " input[name='searchStreet']";

        const equipmentSearch = document.querySelectorAll(keySearch);
        if (equipmentSearch.length === 0) {
            return false;
        }

        keySearch = equipmentSearch[0].value;

        let equipments = [];
        let equipmentInList;
        for (var marker in markers) {
            equipmentInList = markers[marker].coordinates.equipmentKey.toUpperCase();
            if (equipmentInList.match(keySearch.toUpperCase())) {
                equipments.push(markers[marker]);
            }
        }

        this.renderGroupOptions('trucks', equipments);
    };

    this.requestOrder = () => {
        if(this.requestOrdersInProgress) {
            this.requestOrders.abort();
        }
        
        this.requestOrdersInProgress = true;
        const keySearch = document.querySelector(selector + " input[name='searchStreet']").value;
        const query = {
            criteriaChain: []
        };

        query.criteriaChain.push({
            "and": [{
                "attr": "stops.orders.number",
                "eq": keySearch,
                "matchMode": "ANYWHERE"
            }]
        });
        query.criteriaChain[0].and.push({ "attr": "status", "neq": "COMPLETED" });


        this.requestOrders = new DefaultRequest({
            url: 'Route/restrictions?criteria={"filters":["id","stops.id","stops.orders.*","stops.location.*"],"firstResult":0,"maxResults":8}',
            method: 'post',
            data: query,
            success: (data) => {
                this.requestOrdersInProgress = false;
                this.toggleLoadingSpinner();
                var orders = [], ordersToMonetSession = [], orderAndLocation;

                for (var i = 0, size = data.length; i < size; i++) {
                    for (var j = 0, sizeStops = data[i].stops.length; j < sizeStops; j++) {
                        for (var k = 0, sizeOrders = data[i].stops[j].orders.length; k < sizeOrders; k++) {
                            orderAndLocation = {};
                            orderAndLocation.location = data[i].stops[j].location;
                            orderAndLocation.order = data[i].stops[j].orders[k];
                            ordersToMonetSession[orderAndLocation.order.number] = orderAndLocation;
                            orders.push(orderAndLocation);
                        }
                    }
                }

                Monet.Session.Maps.mainMap.orders = ordersToMonetSession;
                this.renderGroupOptions('orders', orders);
            },
            error: () => {
                this.requestOrdersInProgress = false;
                this.toggleLoadingSpinner();
            }
        });
       
        this.requestOrders.send();
    };

    this.requestDriver = () => {
        if(this.requestDriversInProgress) {
            this.requestDrivers.abort();
        }
        this.requestDriversInProgress = true;
        let keySearch = document.querySelector(selector + " input[name='searchStreet']").value;
        const query = {
            criteriaChain: [{
              "and": [{
                "attr": "driverAssignments.driver.name",
                "eq": keySearch,
                "matchMode": "ANYWHERE"
              }, {
                "attr": "status",
                "neq": "COMPLETED"
              }, {
                "attr": "status",
                "neq": "NOT_STARTED"
              }]
            }]
        };

        
        this.requestDrivers = new DefaultRequest({
            url: 'Route/restrictions?criteria={"filters":["id","driverAssignments.driver.name","equipmentAssignments.*","equipmentAssignments.equipment.key"],"firstResult":0,"maxResults":8}',
            method: 'post',
            data: query,
            success: (data) => {
                this.requestDriversInProgress = false;
                this.toggleLoadingSpinner();
                var drivers = [], driverAndEquipment;

                for (var i = 0, size = data.length; i < size; i++) {
                    for (var j = 0, sizeDrivers = data[i].driverAssignments.length; j < sizeDrivers; j++) {
                        driverAndEquipment = {};
                        driverAndEquipment.equipmentKey = data[i].principalEquipment;
                        driverAndEquipment.driverName = data[i].driverAssignments[j].driver.name;
                        drivers.push(driverAndEquipment);
                    }
                }

                this.renderGroupOptions('drivers', drivers);
            },
            error: () => {
                this.requestDriversInProgress = false;
                this.toggleLoadingSpinner();
            }
        });

        this.requestDrivers.send();
    };

    this.requestLocation = () => {
        if(this.requestLocationInProgress) {
            this.requestLocations.abort();
        }
        this.requestLocationInProgress = true;
        let keySearch = document.querySelector(selector + " input[name='searchStreet']").value;

        const query = {
            criteriaChain: [{ "or": [{ "attr": "description", "eq": keySearch, "matchMode": "ANYWHERE" },
                            { "attr": "key", "eq": keySearch, "matchMode": "ANYWHERE" }] }]
        };

        const success = (data) => {
            this.requestLocationInProgress = false;
            this.toggleLoadingSpinner();
            const locationsToMonetSession = [];

            for (let i = 0, size = data.length; i < size; i++) {
                locationsToMonetSession[data[i].id] = data[i];
            }
            Monet.Session.Maps.mainMap.locations = locationsToMonetSession;

            this.renderGroupOptions('locations', data);
        };

        const error = () => {
            this.requestLocationInProgress = false;
            this.toggleLoadingSpinner();
        }

        this.requestLocations = new DefaultRequest({
            url: 'Location/restrictions?criteria={"filters":["*"],"firstResult":0,"maxResults":8}',
            method: 'post',
            data: query,
            success: success,
            error: error
        });

        this.requestLocations.send();
    };

    this.addClickStreetSearchListeners = (e, index) => {

        const lat = ( e.target.getAttribute('lat') !== null ) ? e.target.getAttribute('lat') : e.target[index].getAttribute('lat');
        const lng = ( e.target.getAttribute('lng') !== null ) ? e.target.getAttribute('lng') : e.target[index].getAttribute('lng');
        const address = ( e.target.getAttribute('address') !== null ) ? e.target.getAttribute('address') : e.target[index].getAttribute('address');
        const kind = ( e.target.getAttribute('kind') !== null ) ? e.target.getAttribute('kind') : e.target[index].getAttribute('kind');
        const layers = map._layers;

        if (!lat || kind !== 'marker') {
            return;
        }

        for (let layer in layers) {

            if ([kind, 'LOCATION', 'ORDER' ].indexOf(layers[layer].kind) !== -1) {
                map.removeLayer(layers[layer]);
            }
        }

        Greenmile.Toolbar.Map.Util.addMarkerToMap(lat, lng, address, null, kind, map);

        this.canHide = true;

        this.clearIfCanHide();

    };

    this.addClickEquipmentListeners = function (self, e, index) {
        if (e) {

            var keyEquipment = e.target.getAttribute('key') || e.target[index].getAttribute('key');
            if (!keyEquipment) {
                return;
            }

            setTimeout(this.focusOnEquipemnt(keyEquipment), 250);

            e.stopPropagation();
            this.canHide = true;
            this.clearIfCanHide();

        }
    };

    this.addKeyMultipleListeners = function (context) {
        $(selector + " .streetSearchResult select")
            .on(
            'keydown',
            (e) => {
                if (e.keyCode === ENTER) {

                    var opt = $(selector + " .streetSearchResult select option:selected");
                    var keyEquipment;
                    var kind = opt.attr("kind");
                    var key = opt.attr("key");
                    var markerFunction = {};

                    e.stopPropagation();

                    if (kind === "marker") {
                        var lat = opt.attr("lat");
                        var lng = opt.attr("lng");
                        var address = opt.attr("address");

                        var layers = map._layers;

                        for (var layer in layers) {

                            if (layers[layer].kind === kind) {
                                map.removeLayer(layers[layer]);
                            }

                        }
                        Greenmile.Toolbar.Map.Util.addMarkerToMap(lat, lng, address, null, kind, map);

                       this.clearIfCanHide();

                    } else if (kind === 'EQUIPMENT' || kind === 'DRIVER') {

                        keyEquipment = opt.attr("key");
                        setTimeout(this.focusOnEquipemnt(keyEquipment), 250);
                        this.canHide = true;
                        this.clearIfCanHide();

                    } else if (kind === 'ORDER') {

                        var order = Monet.Session.Maps.mainMap.orders[key];
                        markerFunction = new Greenmile.MarkerOrder.GeneralFunctions();

                        if (!order.location.latitude || !order.location.longitude) {
                            this.showAlertMessage(Monet.I18n.getResourcesByKey("RouteMonitor.LocationWithoutLatLong"));
                        } else {
                            context.renderMarkerOnMap(order, markerFunction);
                        }

                    } else if (kind === 'LOCATION') {
                        var location = Monet.Session.Maps.mainMap.locations[key];
                        markerFunction = new Greenmile.MarkerLocation.GeneralFunctions();

                        if (!location.latitude || !location.longitude) {
                            this.showAlertMessage(Monet.I18n.getResourcesByKey("RouteMonitor.LocationWithoutLatLong"));
                        } else {
                            context.renderMarkerOnMap(location, markerFunction);
                        }
                    }

                } else {
                    if (e.keyCode === TAB) {
                        this.canHide = true;
                        this.clearIfCanHide();
                    }
                }
            });
    };

    this.addClickListenerOnMarkers = (params) => {

        if (!params.location.latitude || !params.location.longitude) {

            this.showAlertMessage(Monet.I18n.getResourcesByKey("RouteMonitor.LocationWithoutLatLong"));
            return;
        }
        this.renderMarkerOnMap(params.object, params.markerFunction);
    };

    this.addClickOrderListeners = (e, index) => {
        const key = e.target.getAttribute('key') || e.target[index].getAttribute('key');
        const order = Monet.Session.Maps.mainMap.orders[key];

        this.addClickListenerOnMarkers ({
            object: order,
            markerFunction: new Greenmile.MarkerOrder.GeneralFunctions(),
            location: order.location
        });

    };

    this.addClickLocationListeners = (e, index) => {

        var key = e.target.getAttribute('key')|| e.target[index].getAttribute('key');
        var location = Monet.Session.Maps.mainMap.locations[key];

        this.addClickListenerOnMarkers ({
            object: location,
            markerFunction: new Greenmile.MarkerLocation.GeneralFunctions(),
            location: location
        });

    };

    this.renderMarkerOnMap = (object, markerFunction) => {

        var marker, markerPosition, position;
        markerFunction.setMap(map);

        markerFunction.removeAllMarkers();
        marker = markerFunction.createMarker(object);
        marker.addTo(map);

        markerPosition = marker.getLatLng();
        position = [markerPosition.lat, markerPosition.lng];

        if (map.getZoom() < 16) {
            map.setZoom(16);
        }

        map.panTo(position);
        marker.openPopup();

        this.canHide =true;
        this.clearIfCanHide();

    };

    this.focusOnEquipemnt = function (equipmentKey) {

        var markerId;

        var markers = Monet.Session.Maps.mainMap.markers, foundEquipment = false;

        var process = function () {
            if (typeof (markers[markerId].coordinates.equipmentKey) !== "undefined" && markers[markerId].coordinates.equipmentKey === equipmentKey) {
                foundEquipment = true;
                (function (m) {

                    App.Routers.RouteMonitor.markers.zoomToShowLayer(m, function () {

                        App.Routers.RouteMonitor.markers.zoomToShowLayer(m, function () {

                            var clusterMarkerFocus;
                            var lat = m._latlng.lat;
                            var lng = m._latlng.lng;
                            var markerFocusIcon;

                            if (typeof (App.Routers.RouteMonitor.prototype.layerFocus) === "undefined") {

                                clusterMarkerFocus = new L.MarkerClusterGroup({
                                    maxClusterRadius: 1,
                                    spiderfyOnMaxZoom: true,
                                    disableClusteringAtZoom: 2,
                                    spiderfyDistanceMultiplier: 3
                                });

                            } else {
                                clusterMarkerFocus = App.Routers.RouteMonitor.prototype.layerFocus;
                            }

                            markerFocusIcon = L.divIcon({
                                html: '<div class="greenmileMarkerFocusIcon"></div>',
                                iconSize: [50, 50]
                            });

                            var markerFocus = new L.marker([lat, lng], {
                                icon: markerFocusIcon,
                                zIndexOffset: -1
                            });

                            clusterMarkerFocus.clearLayers();
                            markerFocus.addTo(clusterMarkerFocus);

                            App.Routers.RouteMonitor.prototype.timeoutLayerFocus =  App.Routers.RouteMonitor.prototype.timeoutLayerFocus || [];
                            Monet.Session.mainMap.map.addLayer(clusterMarkerFocus, true);
                            App.Routers.RouteMonitor.prototype.layerFocus = clusterMarkerFocus;

                            var dismissFocus = function () {
                                App.Routers.RouteMonitor.prototype.layerFocus.clearLayers();
                            };

                            if (App.Routers.RouteMonitor.prototype.timeoutLayerFocus.length > 0) {
                                var timeOuts = App.Routers.RouteMonitor.prototype.timeoutLayerFocus;
                                for (var key in timeOuts) {
                                    clearTimeout(timeOuts[key]);
                                    timeOuts.splice(key, 1);
                                }
                                App.Routers.RouteMonitor.prototype.timeoutLayerFocus = timeOuts;
                            }

                            var timeout = setTimeout(
                                function () {
                                    dismissFocus();
                                },
                                4000);

                            App.Routers.RouteMonitor.prototype.timeoutLayerFocus.push(timeout);

                        });

                    });

                })(markers[markerId]);
            }
        };

        for (var markerId in markers) {
            process();
        }

        if (!foundEquipment) {
            this.showAlertMessage(Monet.I18n.getResourcesByKey("RouteMonitor.EquipmentNotFound"));
        }

    };

    this.showAlertMessage = function (message) {
        toastNotification.addToast({
          id: 'multi-search-on-map-alert',
          type: 'warning',
          variant: 'secondary',
          data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: message,
          }
        });
    };

    this.mountContainerResult = () => {
        handleToolbarSearchContainer.mountSection();

        this.addKeyMultipleListeners(this);
    }

    this.renderGroupOptions = function (idGroup, result) {
        const group = document.querySelector(`${selector} #multiSearchOnMap`);
        
        if (group) {
            group.appendChild(this.renderSearchList(idGroup, result));
        }
    };

    this.renderSearchList = function (idGroup, dataList) {

        var fragment = document.createDocumentFragment();

        if (idGroup === 'address') {
            fragment = this.createListOptionAddress(idGroup, dataList);
        } else if (idGroup === 'trucks') {
            fragment = this.createListOptionEquipment(idGroup, dataList);
        } else if (idGroup === 'drivers') {
            fragment = this.createListOptionDriver(idGroup, dataList);
        } else if (idGroup === 'orders') {
            fragment = this.createListOptionOrder(idGroup, dataList);
        } else if (idGroup === 'locations') {
            fragment = this.createListOptionLocation(idGroup, dataList);
        }


        return fragment;

    };

    this.createListOptionAddress = function (idGroup, dataList) {
        var fragment = document.createDocumentFragment();
        var optGroup = document.querySelector(`${selector} #${idGroup}`);

        if (dataList && dataList.length > 0) {

            if (!optGroup) {
                optGroup = document.createElement('optgroup');
                optGroup.setAttribute("id", idGroup);
                optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.goup.address'));
                optGroup.setAttribute("class", "mapInfo");
            } else {
                optGroup.innerHTML = "";
            }

            for (var i = 0, l = dataList.length; i < l; i++) {

                var option = document.createElement('option');
                option.text = dataList[i].formatted_address;
                option.setAttribute('lat', dataList[i].geometry.location.lat());
                option.setAttribute('lng', dataList[i].geometry.location.lng());
                option.setAttribute('address', dataList[i].formatted_address);
                option.setAttribute('kind', 'marker');
                option.onclick = this.addClickStreetSearchListeners;
                optGroup.appendChild(option);
            }
            fragment.appendChild(optGroup);

        } else if (optGroup) {
            var parent = optGroup.parentElement;
            parent.removeChild(optGroup);
        }
        return fragment;
    };

    this.createListOptionEquipment = function (idGroup, dataList) {
        var fragment = document.createDocumentFragment(), that = this;
        var optGroup = document.querySelector(`${selector} #${idGroup}`);

        if (dataList && dataList.length > 0) {
            if (!optGroup) {
                optGroup = document.createElement('optgroup');
                optGroup.setAttribute("id", idGroup);
                optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.goup.trucks'));
                optGroup.setAttribute("class", "mapInfo");
            } else {
                optGroup.innerHTML = "";
            }

            var clickListener = function (e) {
                that.addClickEquipmentListeners(that, e);
            };

            for (var i = 0, l = dataList.length; i < l; i++) {
                var option = document.createElement('option');
                option.text = dataList[i].coordinates.equipmentKey;
                option.setAttribute('key', dataList[i].coordinates.equipmentKey);
                option.setAttribute('id', "EQUIPMENT_018");
                option.setAttribute('kind', 'EQUIPMENT');
                option.addEventListener('click', clickListener);

                optGroup.appendChild(option);
            }

            fragment.appendChild(optGroup);


        } else if (optGroup) {
            var parent = optGroup.parentElement;
            parent.removeChild(optGroup);
        }
        return fragment;
    };

    this.createListOptionDriver = function (idGroup, dataList) {
        var fragment = document.createDocumentFragment(), that = this;
        var optGroup = document.querySelector(`${selector} #${idGroup}`);

        if (dataList && dataList.length > 0) {

            if (!optGroup) {
                optGroup = document.createElement('optgroup');
                optGroup.setAttribute("id", idGroup);
                optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.goup.drivers'));
                optGroup.setAttribute("class", "mapInfo");
            } else {
                optGroup.innerHTML = "";
            }

            var clickListener = function (e) {
                that.addClickEquipmentListeners(that, e);
            };

            for (var i = 0, l = dataList.length; i < l; i++) {

                var option = document.createElement('option');
                option.text = dataList[i].driverName;
                option.setAttribute('key', dataList[i].equipmentKey);
                option.setAttribute('kind', 'DRIVER');
                option.addEventListener('click', clickListener);
                optGroup.appendChild(option);
            }
            fragment.appendChild(optGroup);

        } else if (optGroup) {
            var parent = optGroup.parentElement;
            parent.removeChild(optGroup);
        }
        return fragment;
    };

    this.createListOptionOrder = function (idGroup, dataList) {
        var fragment = document.createDocumentFragment(), that = this;
        var optGroup = document.querySelector(`${selector} #${idGroup}`);

        if (dataList && dataList.length > 0) {

            if (!optGroup) {
                optGroup = document.createElement('optgroup');
                optGroup.setAttribute("id", idGroup);
                optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.goup.orders'));
                optGroup.setAttribute("class", "mapInfo");
            } else {
                optGroup.innerHTML = "";
            }

            var clickListener = function (e) {
                that.addClickOrderListeners(e, that);
            };

            for (var i = 0, l = dataList.length; i < l; i++) {
                var option = document.createElement('option');
                option.text = dataList[i].order.number;

                option.setAttribute('key', dataList[i].order.number);
                option.setAttribute('kind', 'ORDER');
                option.addEventListener('click', clickListener);

                optGroup.appendChild(option);
            }
            fragment.appendChild(optGroup);

        } else if (optGroup) {
            var parent = optGroup.parentElement;
            parent.removeChild(optGroup);
        }
        return fragment;
    };

    this.createListOptionLocation = (idGroup, dataList) => {
        var fragment = document.createDocumentFragment();
        var optGroup = document.querySelector(`${selector} #${idGroup}`);

        if (dataList && dataList.length > 0) {

            if (!optGroup) {
                optGroup = document.createElement('optgroup');
                optGroup.setAttribute("id", "locations");
                optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.group.locations'));
                optGroup.setAttribute("class", "mapInfo");
            } else {
                optGroup.innerHTML = "";
            }

            var clickListener = (e) => {
                this.addClickLocationListeners(e);
            };

            for (var i = 0, l = dataList.length; i < l; i++) {
                var option = document.createElement('option');
                option.text = dataList[i].key + " - " + dataList[i].description;

                option.setAttribute('key', dataList[i].id);
                option.setAttribute('kind', 'LOCATION');
                option.addEventListener('click', clickListener);

                optGroup.appendChild(option);
            }

            fragment.appendChild(optGroup);

        } else if (optGroup) {
            var parent = optGroup.parentElement;
            parent.removeChild(optGroup);
        }
        return fragment;
    };

  $(selector).off("keydown", this.searchAddressOnMap.finish);
  $(selector).on("keydown", this.searchAddressOnMap.finish);

};